angular.module('TetherApp').factory('formTemplateService', [
    'templateService',
    'surveyTemplateService',
    'smsTemplateService',
    'externalTemplateService',
    'sweepstakesTemplateService',
    'sweepstakesPrizingTemplateService',
    function (
        templateService,
        surveyTemplateService,
        smsTemplateService,
        externalTemplateService,
        sweepstakesTemplateService,
        sweepstakesPrizingTemplateService
    ) {

        let formTemplates = {
            survey: surveyTemplateService.form,
            sms: smsTemplateService.form,
            external: externalTemplateService.form,
            sweepstakes: sweepstakesTemplateService.form,
            sweepstakesPrizing: sweepstakesPrizingTemplateService.form
        };

        let getFormCreatorFields = function (currentObject, div) {

            let fieldList = [];
            let fieldCount = 1;

            for (let objKey in currentObject) {

                let type = currentObject[objKey]['type'];
                let options = div.attributes.options;

                //for (let objProp in currentObject[objKey]){
                //    console.log('objProp is ' + objProp + ' currentObject[objKey] is ' + currentObject[objKey]);
                //}

                let fieldOption = {};

                for (let index in options) {
                    if (options[index].value == type) {

                        fieldOption = options[index];

                        for (let property in options[index].properties) {

                            if (options[index].properties[property].name == 'text') {
                                options[index].properties[property].input = currentObject[objKey]['text'];
                            } else if (options[index].properties[property].name == 'placeholder') {
                                options[index].properties[property].input = currentObject[objKey]['placeholder'];
                            }

                        }

                    }
                }

                let field = {
                    id: fieldCount,
                    type: type,
                    templateUrl: templateService.getTemplateUrl(fieldOption.templateName),
                    selectedValue: fieldOption
                };

                fieldList.push(field);

                fieldCount += 1;

            }

            return fieldList;
        };

        let getOptions = function (currentObject, div) {
            let options = undefined;

            if (typeof currentObject === 'object' && currentObject.hasOwnProperty('options')) {
                options = currentObject['options'];
            }

            return options;
        };

        let setSelectedValue = function (currentObject, div, input) {
            let selectedValue = {};

            for (let key in div.attributes.options) {
                if (div.attributes.options[key].value == input[div.attributes.name]) {
                    selectedValue = div.attributes.options[key];
                    break;
                }
            }

            return selectedValue;
        };

        let formTemplate = function (templateName, errors, input, populate) {
            let formData = formTemplates[templateName];
            let divs = formData.divs;

            if (errors !== undefined || input !== undefined || populate !== undefined) {
                for (let key in divs) {

                    if (errors !== null && errors !== undefined && errors.hasOwnProperty(divs[key].attributes.name)) {
                        divs[key].attributes.errors = errors[divs[key].attributes.name];
                    }

                    if (populate !== null && populate !== undefined && populate.hasOwnProperty(divs[key].attributes.name)) {
                        if (typeof populate[divs[key].attributes.name] === 'object') {
                            let currentObject = populate[divs[key].attributes.name];

                            if (divs[key].attributes.hasOwnProperty('options')) {
                                divs[key].attributes.options = getOptions(currentObject, divs[key]);
                            } else if (divs[key].attributes.hasOwnProperty('radios')) {
                                // console.log('Radios');
                            }
                        }
                    }

                    if (input !== null && input !== undefined && input.hasOwnProperty(divs[key].attributes.name)) {

                        if (typeof input[divs[key].attributes.name] === 'object') {
                            let currentObject = input[divs[key].attributes.name];

                            if (divs[key].attributes.hasOwnProperty('fields')) {
                                divs[key].attributes.fields = getFormCreatorFields(currentObject, divs[key]);
                            } else if (divs[key].attributes.hasOwnProperty('options')) {
                                // console.log('Options');
                                //May not be needed
                            } else if (divs[key].attributes.hasOwnProperty('radios')) {
                                // console.log('Radios');
                                //May not be needed
                            } else {
                                divs[key].attributes.input = input[divs[key].attributes.name];
                            }
                        } else {
                            if (divs[key].attributes.hasOwnProperty('options')) {
                                divs[key].attributes.selectedValue = setSelectedValue(currentObject, divs[key], input);
                            } else {
                                divs[key].attributes.input = input[divs[key].attributes.name];
                            }
                        }
                    }
                }
            }

            return formData;

        };

        return {
            formTemplate: formTemplate
        };

    }
]);
